import { render, staticRenderFns } from "./Alkoholfrei.vue?vue&type=template&id=c6976e34&scoped=true"
import script from "./Alkoholfrei.vue?vue&type=script&lang=js"
export * from "./Alkoholfrei.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6976e34",
  null
  
)

export default component.exports